/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { AccessTokenModalWarningTimeSetting } from './AccessTokenModalWarningTimeSetting';
import { AccessTokenToastWarningTimeSetting } from './AccessTokenToastWarningTimeSetting';
import { AiAssistantEnabledSetting } from './AiAssistantEnabledSetting';
import { AlwaysUpdatePiiWithLtiSetting } from './AlwaysUpdatePiiWithLtiSetting';
import { AssignmentDefaultGradingScalePointsSetting } from './AssignmentDefaultGradingScalePointsSetting';
import { AssignmentDefaultGradingScaleSetting } from './AssignmentDefaultGradingScaleSetting';
import { AssignmentDescriptionOnTeachersSubmissionsPageSetting } from './AssignmentDescriptionOnTeachersSubmissionsPageSetting';
import { AssignmentMaxPointsEnabledSetting } from './AssignmentMaxPointsEnabledSetting';
import { AssignmentPercentageDecimalsSetting } from './AssignmentPercentageDecimalsSetting';
import { AssignmentPointDecimalsSetting } from './AssignmentPointDecimalsSetting';
import { AssistantToolsEnabledSetting } from './AssistantToolsEnabledSetting';
import { AtImageCachingEnabledSetting } from './AtImageCachingEnabledSetting';
import { AutomaticLti1p3AssignmentImportSetting } from './AutomaticLti1p3AssignmentImportSetting';
import { AutomaticLtiRoleEnabledSetting } from './AutomaticLtiRoleEnabledSetting';
import { AutoTestCapturePointsMessageSetting } from './AutoTestCapturePointsMessageSetting';
import { AutoTestCheckpointMessageSetting } from './AutoTestCheckpointMessageSetting';
import { AutoTestCodeQualityMessageSetting } from './AutoTestCodeQualityMessageSetting';
import { AutoTestEnabledSetting } from './AutoTestEnabledSetting';
import { AutoTestHeartbeatIntervalSetting } from './AutoTestHeartbeatIntervalSetting';
import { AutoTestHeartbeatMaxMissedSetting } from './AutoTestHeartbeatMaxMissedSetting';
import { AutoTestIoTestMessageSetting } from './AutoTestIoTestMessageSetting';
import { AutoTestIoTestSubMessageSetting } from './AutoTestIoTestSubMessageSetting';
import { AutoTestMaxConcurrentBatchRunsSetting } from './AutoTestMaxConcurrentBatchRunsSetting';
import { AutoTestMaxGlobalSetupTimeSetting } from './AutoTestMaxGlobalSetupTimeSetting';
import { AutoTestMaxJobsPerRunnerSetting } from './AutoTestMaxJobsPerRunnerSetting';
import { AutoTestMaxPerStudentSetupTimeSetting } from './AutoTestMaxPerStudentSetupTimeSetting';
import { AutoTestMaxResultNotStartedSetting } from './AutoTestMaxResultNotStartedSetting';
import { AutoTestMaxTimeCommandSetting } from './AutoTestMaxTimeCommandSetting';
import { AutoTestMaxUnitTestMetadataLengthSetting } from './AutoTestMaxUnitTestMetadataLengthSetting';
import { AutoTestRunProgramMessageSetting } from './AutoTestRunProgramMessageSetting';
import { AutoTestUnitTestMessageSetting } from './AutoTestUnitTestMessageSetting';
import { BlackboardZipUploadEnabledSetting } from './BlackboardZipUploadEnabledSetting';
import { CanvasCourseIdCopyingEnabledSetting } from './CanvasCourseIdCopyingEnabledSetting';
import { CodeEditorOutputViewerTitleSetting } from './CodeEditorOutputViewerTitleSetting';
import { CodeEditorStartOnAssignmentDescriptionSetting } from './CodeEditorStartOnAssignmentDescriptionSetting';
import { CodingQuestionEditorResetAnswerEnabledSetting } from './CodingQuestionEditorResetAnswerEnabledSetting';
import { CodingQuestionSolutionEnabledSetting } from './CodingQuestionSolutionEnabledSetting';
import { CommunityLibraryPublishingSetting } from './CommunityLibraryPublishingSetting';
import { CommunityLibrarySetting } from './CommunityLibrarySetting';
import { CourseBulkRegisterEnabledSetting } from './CourseBulkRegisterEnabledSetting';
import { CourseGradebookRenderWarningSizeSetting } from './CourseGradebookRenderWarningSizeSetting';
import { CourseRegisterEnabledSetting } from './CourseRegisterEnabledSetting';
import { CsvLargeFileLimitSetting } from './CsvLargeFileLimitSetting';
import { CsvTooManyErrorsLimitSetting } from './CsvTooManyErrorsLimitSetting';
import { DefaultCourseTaRoleSetting } from './DefaultCourseTaRoleSetting';
import { DefaultCourseTeacherRoleSetting } from './DefaultCourseTeacherRoleSetting';
import { DefaultSubmissionPageTabSetting } from './DefaultSubmissionPageTabSetting';
import { DisplayGradesEnabledSetting } from './DisplayGradesEnabledSetting';
import { DownloadEditorFilesEnabledSetting } from './DownloadEditorFilesEnabledSetting';
import { EditorEnabledSetting } from './EditorEnabledSetting';
import { EmailStudentsEnabledSetting } from './EmailStudentsEnabledSetting';
import { ExamLoginMaxLengthSetting } from './ExamLoginMaxLengthSetting';
import { FeedbackThreadsInitiallyCollapsedSetting } from './FeedbackThreadsInitiallyCollapsedSetting';
import { FirstDayOfWeekFromLocaleSetting } from './FirstDayOfWeekFromLocaleSetting';
import { GithubTemplateRepoEnabledSetting } from './GithubTemplateRepoEnabledSetting';
import { GradingNotificationsEnabledSetting } from './GradingNotificationsEnabledSetting';
import { GroupsEnabledSetting } from './GroupsEnabledSetting';
import { HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting } from './HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting';
import { HideCodeEditorOutputViewerWithOnlyQuizStepsSetting } from './HideCodeEditorOutputViewerWithOnlyQuizStepsSetting';
import { HideEmptyRubricRowDescriptionSetting } from './HideEmptyRubricRowDescriptionSetting';
import { HideNoDeadlineEnabledSetting } from './HideNoDeadlineEnabledSetting';
import { HubspotSyncingEnabledSetting } from './HubspotSyncingEnabledSetting';
import { InlineFeedbackOnQuizzesEnabledSetting } from './InlineFeedbackOnQuizzesEnabledSetting';
import { InlineRubricViewerEnabledSetting } from './InlineRubricViewerEnabledSetting';
import { IsPearsonSetting } from './IsPearsonSetting';
import { JupyterNotebookEditorEnabledSetting } from './JupyterNotebookEditorEnabledSetting';
import { JupyterNotebookRunningEnabledSetting } from './JupyterNotebookRunningEnabledSetting';
import { JwtAccessTokenExpiresSetting } from './JwtAccessTokenExpiresSetting';
import { LoginTokenBeforeTimeSetting } from './LoginTokenBeforeTimeSetting';
import { Lti1p3NonceAndStateValidationEnabledSetting } from './Lti1p3NonceAndStateValidationEnabledSetting';
import { Lti1p3PreventNonceReuseEnabledSetting } from './Lti1p3PreventNonceReuseEnabledSetting';
import { Lti1p3SystemRoleFromContextRoleSetting } from './Lti1p3SystemRoleFromContextRoleSetting';
import { LtiLaunchDataLoggingSetting } from './LtiLaunchDataLoggingSetting';
import { LtiLockDateCopyingEnabledSetting } from './LtiLockDateCopyingEnabledSetting';
import { LtiRoleSwitchingSetting } from './LtiRoleSwitchingSetting';
import { LtiUnsetDeadlineLockDateEnabledSetting } from './LtiUnsetDeadlineLockDateEnabledSetting';
import { MaxDocumentUpdateSizeSetting } from './MaxDocumentUpdateSizeSetting';
import { MaxDynamoFileSizeSetting } from './MaxDynamoFileSizeSetting';
import { MaxDynamoSubmissionSizeSetting } from './MaxDynamoSubmissionSizeSetting';
import { MaxFileSizeSetting } from './MaxFileSizeSetting';
import { MaxLargeUploadSizeSetting } from './MaxLargeUploadSizeSetting';
import { MaxLinesSetting } from './MaxLinesSetting';
import { MaxNormalUploadSizeSetting } from './MaxNormalUploadSizeSetting';
import { MaxNumberOfFilesSetting } from './MaxNumberOfFilesSetting';
import { MaxPlagiarismMatchesSetting } from './MaxPlagiarismMatchesSetting';
import { MaxUserSettingAmountSetting } from './MaxUserSettingAmountSetting';
import { MinPasswordScoreSetting } from './MinPasswordScoreSetting';
import { NameAndEmailFromNrpsOnlySetting } from './NameAndEmailFromNrpsOnlySetting';
import { NewAutoTestAllowedInitialBuildIdsSetting } from './NewAutoTestAllowedInitialBuildIdsSetting';
import { NewAutoTestBuildMaxCommandTimeSetting } from './NewAutoTestBuildMaxCommandTimeSetting';
import { NewAutoTestBuildOutputLimitSetting } from './NewAutoTestBuildOutputLimitSetting';
import { NewAutoTestCurrentInitialBuildIdsSetting } from './NewAutoTestCurrentInitialBuildIdsSetting';
import { NewAutoTestDiffViewerEnabledSetting } from './NewAutoTestDiffViewerEnabledSetting';
import { NewAutoTestInitialBuildIdSetting } from './NewAutoTestInitialBuildIdSetting';
import { NewAutoTestMaxDynamodbSizeSetting } from './NewAutoTestMaxDynamodbSizeSetting';
import { NewAutoTestMaxFileSizeSetting } from './NewAutoTestMaxFileSizeSetting';
import { NewAutoTestMaxOutputFilesSizeSetting } from './NewAutoTestMaxOutputFilesSizeSetting';
import { NewAutoTestMaxStorageSizeSetting } from './NewAutoTestMaxStorageSizeSetting';
import { NewAutoTestOldSubmissionAgeSetting } from './NewAutoTestOldSubmissionAgeSetting';
import { NewAutoTestTestMaxCommandTimeSetting } from './NewAutoTestTestMaxCommandTimeSetting';
import { NewAutoTestTestOutputLimitSetting } from './NewAutoTestTestOutputLimitSetting';
import { NewAutoTestUncollapsingStepOutputDelaySetting } from './NewAutoTestUncollapsingStepOutputDelaySetting';
import { NewStudentAssignmentOverviewEnabledSetting } from './NewStudentAssignmentOverviewEnabledSetting';
import { NotificationPollTimeSetting } from './NotificationPollTimeSetting';
import { OutputViewerAnimationLimitLinesCountSetting } from './OutputViewerAnimationLimitLinesCountSetting';
import { OutputViewerAutoExpandFailedStepsSetting } from './OutputViewerAutoExpandFailedStepsSetting';
import { PaymentsProviderSetting } from './PaymentsProviderSetting';
import { PearsonTemplatesSetting } from './PearsonTemplatesSetting';
import { PeerFeedbackEnabledSetting } from './PeerFeedbackEnabledSetting';
import { PerCoursePaymentAllowedSetting } from './PerCoursePaymentAllowedSetting';
import { PromptEngineeringStepEnabledSetting } from './PromptEngineeringStepEnabledSetting';
import { QualityCommentsInCodeEditorSetting } from './QualityCommentsInCodeEditorSetting';
import { QuizMinimumQuestionsForDropdownSetting } from './QuizMinimumQuestionsForDropdownSetting';
import { QuizSingleQuestionModeHideRunButtonEnabledSetting } from './QuizSingleQuestionModeHideRunButtonEnabledSetting';
import { QuizViewModesEnabledSetting } from './QuizViewModesEnabledSetting';
import { RegexAtv2ExplanationEnabledSetting } from './RegexAtv2ExplanationEnabledSetting';
import { RegisterEnabledSetting } from './RegisterEnabledSetting';
import { ReleaseMessageMaxTimeSetting } from './ReleaseMessageMaxTimeSetting';
import { RenderHtmlEnabledSetting } from './RenderHtmlEnabledSetting';
import { ResetTokenTimeSetting } from './ResetTokenTimeSetting';
import { RetryGroupSubmissionGradePassbackEnabledSetting } from './RetryGroupSubmissionGradePassbackEnabledSetting';
import { RubricConvertUseAtv2EnabledSetting } from './RubricConvertUseAtv2EnabledSetting';
import { RubricEnabledForTeacherOnSubmissionsPageSetting } from './RubricEnabledForTeacherOnSubmissionsPageSetting';
import { SendRegistrationEmailSetting } from './SendRegistrationEmailSetting';
import { ServerTimeCorrectionEnabledSetting } from './ServerTimeCorrectionEnabledSetting';
import { ServerTimeDiffToleranceSetting } from './ServerTimeDiffToleranceSetting';
import { ServerTimeSyncIntervalSetting } from './ServerTimeSyncIntervalSetting';
import { SettingTokenTimeSetting } from './SettingTokenTimeSetting';
import { SimpleSubmissionNavigateToLatestEditorSessionSetting } from './SimpleSubmissionNavigateToLatestEditorSessionSetting';
import { SiteEmailSetting } from './SiteEmailSetting';
import { SsoInferGlobalStaffRoleSetting } from './SsoInferGlobalStaffRoleSetting';
import { SsoUsernameDecollisionEnabledSetting } from './SsoUsernameDecollisionEnabledSetting';
import { StudentPaymentEnabledSetting } from './StudentPaymentEnabledSetting';
import { StudentPaymentMainOptionSetting } from './StudentPaymentMainOptionSetting';
import { WarningForMissingNewlineEnabledSetting } from './WarningForMissingNewlineEnabledSetting';
const SiteSettingInputParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.taggedUnion('name', [
    ['AUTO_TEST_MAX_TIME_COMMAND', AutoTestMaxTimeCommandSetting],
    ['AUTO_TEST_HEARTBEAT_INTERVAL', AutoTestHeartbeatIntervalSetting],
    ['AUTO_TEST_HEARTBEAT_MAX_MISSED', AutoTestHeartbeatMaxMissedSetting],
    ['AUTO_TEST_MAX_JOBS_PER_RUNNER', AutoTestMaxJobsPerRunnerSetting],
    ['AUTO_TEST_MAX_CONCURRENT_BATCH_RUNS', AutoTestMaxConcurrentBatchRunsSetting],
    ['AUTO_TEST_IO_TEST_MESSAGE', AutoTestIoTestMessageSetting],
    ['AUTO_TEST_IO_TEST_SUB_MESSAGE', AutoTestIoTestSubMessageSetting],
    ['AUTO_TEST_RUN_PROGRAM_MESSAGE', AutoTestRunProgramMessageSetting],
    ['AUTO_TEST_CAPTURE_POINTS_MESSAGE', AutoTestCapturePointsMessageSetting],
    ['AUTO_TEST_CHECKPOINT_MESSAGE', AutoTestCheckpointMessageSetting],
    ['AUTO_TEST_UNIT_TEST_MESSAGE', AutoTestUnitTestMessageSetting],
    ['AUTO_TEST_CODE_QUALITY_MESSAGE', AutoTestCodeQualityMessageSetting],
    ['AUTO_TEST_MAX_RESULT_NOT_STARTED', AutoTestMaxResultNotStartedSetting],
    ['AUTO_TEST_MAX_UNIT_TEST_METADATA_LENGTH', AutoTestMaxUnitTestMetadataLengthSetting],
    ['NEW_AUTO_TEST_MAX_DYNAMODB_SIZE', NewAutoTestMaxDynamodbSizeSetting],
    ['NEW_AUTO_TEST_MAX_STORAGE_SIZE', NewAutoTestMaxStorageSizeSetting],
    ['NEW_AUTO_TEST_MAX_FILE_SIZE', NewAutoTestMaxFileSizeSetting],
    ['NEW_AUTO_TEST_BUILD_OUTPUT_LIMIT', NewAutoTestBuildOutputLimitSetting],
    ['NEW_AUTO_TEST_TEST_OUTPUT_LIMIT', NewAutoTestTestOutputLimitSetting],
    ['NEW_AUTO_TEST_MAX_OUTPUT_FILES_SIZE', NewAutoTestMaxOutputFilesSizeSetting],
    ['NEW_AUTO_TEST_CURRENT_INITIAL_BUILD_IDS', NewAutoTestCurrentInitialBuildIdsSetting],
    ['NEW_AUTO_TEST_ALLOWED_INITIAL_BUILD_IDS', NewAutoTestAllowedInitialBuildIdsSetting],
    ['NEW_AUTO_TEST_INITIAL_BUILD_ID', NewAutoTestInitialBuildIdSetting],
    ['NEW_AUTO_TEST_BUILD_MAX_COMMAND_TIME', NewAutoTestBuildMaxCommandTimeSetting],
    ['NEW_AUTO_TEST_TEST_MAX_COMMAND_TIME', NewAutoTestTestMaxCommandTimeSetting],
    ['CODE_EDITOR_OUTPUT_VIEWER_TITLE', CodeEditorOutputViewerTitleSetting],
    ['QUIZ_MINIMUM_QUESTIONS_FOR_DROPDOWN', QuizMinimumQuestionsForDropdownSetting],
    ['EXAM_LOGIN_MAX_LENGTH', ExamLoginMaxLengthSetting],
    ['LOGIN_TOKEN_BEFORE_TIME', LoginTokenBeforeTimeSetting],
    ['MIN_PASSWORD_SCORE', MinPasswordScoreSetting],
    ['RESET_TOKEN_TIME', ResetTokenTimeSetting],
    ['SETTING_TOKEN_TIME', SettingTokenTimeSetting],
    ['SITE_EMAIL', SiteEmailSetting],
    ['MAX_NUMBER_OF_FILES', MaxNumberOfFilesSetting],
    ['MAX_LARGE_UPLOAD_SIZE', MaxLargeUploadSizeSetting],
    ['MAX_NORMAL_UPLOAD_SIZE', MaxNormalUploadSizeSetting],
    ['MAX_DYNAMO_SUBMISSION_SIZE', MaxDynamoSubmissionSizeSetting],
    ['MAX_FILE_SIZE', MaxFileSizeSetting],
    ['MAX_DYNAMO_FILE_SIZE', MaxDynamoFileSizeSetting],
    ['MAX_DOCUMENT_UPDATE_SIZE', MaxDocumentUpdateSizeSetting],
    ['JWT_ACCESS_TOKEN_EXPIRES', JwtAccessTokenExpiresSetting],
    ['ACCESS_TOKEN_TOAST_WARNING_TIME', AccessTokenToastWarningTimeSetting],
    ['ACCESS_TOKEN_MODAL_WARNING_TIME', AccessTokenModalWarningTimeSetting],
    ['MAX_LINES', MaxLinesSetting],
    ['NOTIFICATION_POLL_TIME', NotificationPollTimeSetting],
    ['RELEASE_MESSAGE_MAX_TIME', ReleaseMessageMaxTimeSetting],
    ['MAX_PLAGIARISM_MATCHES', MaxPlagiarismMatchesSetting],
    ['AUTO_TEST_MAX_GLOBAL_SETUP_TIME', AutoTestMaxGlobalSetupTimeSetting],
    ['AUTO_TEST_MAX_PER_STUDENT_SETUP_TIME', AutoTestMaxPerStudentSetupTimeSetting],
    ['ASSIGNMENT_DEFAULT_GRADING_SCALE', AssignmentDefaultGradingScaleSetting],
    ['ASSIGNMENT_DEFAULT_GRADING_SCALE_POINTS', AssignmentDefaultGradingScalePointsSetting],
    ['BLACKBOARD_ZIP_UPLOAD_ENABLED', BlackboardZipUploadEnabledSetting],
    [
        'RUBRIC_ENABLED_FOR_TEACHER_ON_SUBMISSIONS_PAGE',
        RubricEnabledForTeacherOnSubmissionsPageSetting,
    ],
    ['AUTOMATIC_LTI_ROLE_ENABLED', AutomaticLtiRoleEnabledSetting],
    ['REGISTER_ENABLED', RegisterEnabledSetting],
    ['GROUPS_ENABLED', GroupsEnabledSetting],
    ['AUTO_TEST_ENABLED', AutoTestEnabledSetting],
    ['COURSE_REGISTER_ENABLED', CourseRegisterEnabledSetting],
    ['RENDER_HTML_ENABLED', RenderHtmlEnabledSetting],
    ['EMAIL_STUDENTS_ENABLED', EmailStudentsEnabledSetting],
    ['PEER_FEEDBACK_ENABLED', PeerFeedbackEnabledSetting],
    ['AT_IMAGE_CACHING_ENABLED', AtImageCachingEnabledSetting],
    ['STUDENT_PAYMENT_ENABLED', StudentPaymentEnabledSetting],
    ['STUDENT_PAYMENT_MAIN_OPTION', StudentPaymentMainOptionSetting],
    ['EDITOR_ENABLED', EditorEnabledSetting],
    ['SERVER_TIME_CORRECTION_ENABLED', ServerTimeCorrectionEnabledSetting],
    ['GRADING_NOTIFICATIONS_ENABLED', GradingNotificationsEnabledSetting],
    ['SSO_USERNAME_DECOLLISION_ENABLED', SsoUsernameDecollisionEnabledSetting],
    ['FEEDBACK_THREADS_INITIALLY_COLLAPSED', FeedbackThreadsInitiallyCollapsedSetting],
    ['MAX_USER_SETTING_AMOUNT', MaxUserSettingAmountSetting],
    ['SEND_REGISTRATION_EMAIL', SendRegistrationEmailSetting],
    ['SERVER_TIME_DIFF_TOLERANCE', ServerTimeDiffToleranceSetting],
    ['SERVER_TIME_SYNC_INTERVAL', ServerTimeSyncIntervalSetting],
    ['AUTOMATIC_LTI_1P3_ASSIGNMENT_IMPORT', AutomaticLti1p3AssignmentImportSetting],
    ['ASSIGNMENT_PERCENTAGE_DECIMALS', AssignmentPercentageDecimalsSetting],
    ['ASSIGNMENT_POINT_DECIMALS', AssignmentPointDecimalsSetting],
    [
        'OUTPUT_VIEWER_ANIMATION_LIMIT_LINES_COUNT',
        OutputViewerAnimationLimitLinesCountSetting,
    ],
    ['OUTPUT_VIEWER_AUTO_EXPAND_FAILED_STEPS', OutputViewerAutoExpandFailedStepsSetting],
    ['LTI_LOCK_DATE_COPYING_ENABLED', LtiLockDateCopyingEnabledSetting],
    ['ASSIGNMENT_MAX_POINTS_ENABLED', AssignmentMaxPointsEnabledSetting],
    ['COURSE_GRADEBOOK_RENDER_WARNING_SIZE', CourseGradebookRenderWarningSizeSetting],
    ['COURSE_BULK_REGISTER_ENABLED', CourseBulkRegisterEnabledSetting],
    ['CSV_LARGE_FILE_LIMIT', CsvLargeFileLimitSetting],
    ['CSV_TOO_MANY_ERRORS_LIMIT', CsvTooManyErrorsLimitSetting],
    ['NEW_AUTO_TEST_OLD_SUBMISSION_AGE', NewAutoTestOldSubmissionAgeSetting],
    ['CANVAS_COURSE_ID_COPYING_ENABLED', CanvasCourseIdCopyingEnabledSetting],
    ['NEW_AUTO_TEST_DIFF_VIEWER_ENABLED', NewAutoTestDiffViewerEnabledSetting],
    ['LTI_UNSET_DEADLINE_LOCK_DATE_ENABLED', LtiUnsetDeadlineLockDateEnabledSetting],
    ['GITHUB_TEMPLATE_REPO_ENABLED', GithubTemplateRepoEnabledSetting],
    ['COMMUNITY_LIBRARY', CommunityLibrarySetting],
    ['COMMUNITY_LIBRARY_PUBLISHING', CommunityLibraryPublishingSetting],
    ['LTI_1P3_SYSTEM_ROLE_FROM_CONTEXT_ROLE', Lti1p3SystemRoleFromContextRoleSetting],
    ['QUALITY_COMMENTS_IN_CODE_EDITOR', QualityCommentsInCodeEditorSetting],
    ['SSO_INFER_GLOBAL_STAFF_ROLE', SsoInferGlobalStaffRoleSetting],
    [
        'NEW_AUTO_TEST_UNCOLLAPSING_STEP_OUTPUT_DELAY',
        NewAutoTestUncollapsingStepOutputDelaySetting,
    ],
    [
        'ASSIGNMENT_DESCRIPTION_ON_TEACHERS_SUBMISSIONS_PAGE',
        AssignmentDescriptionOnTeachersSubmissionsPageSetting,
    ],
    ['INLINE_RUBRIC_VIEWER_ENABLED', InlineRubricViewerEnabledSetting],
    ['LTI_LAUNCH_DATA_LOGGING', LtiLaunchDataLoggingSetting],
    [
        'HIDE_CODE_EDITOR_OUTPUT_VIEWER_WITH_ONLY_QUIZ_STEPS',
        HideCodeEditorOutputViewerWithOnlyQuizStepsSetting,
    ],
    [
        'HIDE_CODE_EDITOR_FILETREE_CONTROLS_WITH_ONLY_QUIZ_STEPS',
        HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting,
    ],
    ['PEARSON_TEMPLATES', PearsonTemplatesSetting],
    [
        'SIMPLE_SUBMISSION_NAVIGATE_TO_LATEST_EDITOR_SESSION',
        SimpleSubmissionNavigateToLatestEditorSessionSetting,
    ],
    ['DISPLAY_GRADES_ENABLED', DisplayGradesEnabledSetting],
    ['HIDE_EMPTY_RUBRIC_ROW_DESCRIPTION', HideEmptyRubricRowDescriptionSetting],
    ['DEFAULT_COURSE_TEACHER_ROLE', DefaultCourseTeacherRoleSetting],
    ['DEFAULT_COURSE_TA_ROLE', DefaultCourseTaRoleSetting],
    [
        'LTI_1P3_NONCE_AND_STATE_VALIDATION_ENABLED',
        Lti1p3NonceAndStateValidationEnabledSetting,
    ],
    ['LTI_1P3_PREVENT_NONCE_REUSE_ENABLED', Lti1p3PreventNonceReuseEnabledSetting],
    ['DEFAULT_SUBMISSION_PAGE_TAB', DefaultSubmissionPageTabSetting],
    ['NAME_AND_EMAIL_FROM_NRPS_ONLY', NameAndEmailFromNrpsOnlySetting],
    ['ALWAYS_UPDATE_PII_WITH_LTI', AlwaysUpdatePiiWithLtiSetting],
    ['HUBSPOT_SYNCING_ENABLED', HubspotSyncingEnabledSetting],
    ['HIDE_NO_DEADLINE_ENABLED', HideNoDeadlineEnabledSetting],
    [
        'RETRY_GROUP_SUBMISSION_GRADE_PASSBACK_ENABLED',
        RetryGroupSubmissionGradePassbackEnabledSetting,
    ],
    [
        'CODE_EDITOR_START_ON_ASSIGNMENT_DESCRIPTION',
        CodeEditorStartOnAssignmentDescriptionSetting,
    ],
    ['AI_ASSISTANT_ENABLED', AiAssistantEnabledSetting],
    ['ASSISTANT_TOOLS_ENABLED', AssistantToolsEnabledSetting],
    ['PROMPT_ENGINEERING_STEP_ENABLED', PromptEngineeringStepEnabledSetting],
    ['FIRST_DAY_OF_WEEK_FROM_LOCALE', FirstDayOfWeekFromLocaleSetting],
    ['INLINE_FEEDBACK_ON_QUIZZES_ENABLED', InlineFeedbackOnQuizzesEnabledSetting],
    ['IS_PEARSON', IsPearsonSetting],
    [
        'QUIZ_SINGLE_QUESTION_MODE_HIDE_RUN_BUTTON_ENABLED',
        QuizSingleQuestionModeHideRunButtonEnabledSetting,
    ],
    ['WARNING_FOR_MISSING_NEWLINE_ENABLED', WarningForMissingNewlineEnabledSetting],
    ['JUPYTER_NOTEBOOK_EDITOR_ENABLED', JupyterNotebookEditorEnabledSetting],
    ['JUPYTER_NOTEBOOK_RUNNING_ENABLED', JupyterNotebookRunningEnabledSetting],
    ['LTI_ROLE_SWITCHING', LtiRoleSwitchingSetting],
    [
        'CODING_QUESTION_EDITOR_RESET_ANSWER_ENABLED',
        CodingQuestionEditorResetAnswerEnabledSetting,
    ],
    ['CODING_QUESTION_SOLUTION_ENABLED', CodingQuestionSolutionEnabledSetting],
    ['PER_COURSE_PAYMENT_ALLOWED', PerCoursePaymentAllowedSetting],
    ['DOWNLOAD_EDITOR_FILES_ENABLED', DownloadEditorFilesEnabledSetting],
    ['PAYMENTS_PROVIDER', PaymentsProviderSetting],
    ['QUIZ_VIEW_MODES_ENABLED', QuizViewModesEnabledSetting],
    ['RUBRIC_CONVERT_USE_ATV2_ENABLED', RubricConvertUseAtv2EnabledSetting],
    ['REGEX_ATV2_EXPLANATION_ENABLED', RegexAtv2ExplanationEnabledSetting],
    ['NEW_STUDENT_ASSIGNMENT_OVERVIEW_ENABLED', NewStudentAssignmentOverviewEnabledSetting],
]));
export const SiteSettingInput = SiteSettingInputParser;
